import React from 'react';
import styled from 'styled-components';
import FieldTournamentId from './FieldTournamentId';
import SearchInput from './SearchInput';
import TabsParticipants from './TabsParticipants';

const Wrapper = styled.article`
    width: 308px;
    padding-left: 16px;
`;

const Header = styled.header`
    margin-bottom: 14px;
`;

function ParticipantsPicker() {
    return (
        <Wrapper>
            <Header>
                <FieldTournamentId />
                <SearchInput />
            </Header>
            <TabsParticipants />
        </Wrapper>
    );
}

export default ParticipantsPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/ParticipantsPicker.js
 **/